import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

interface CardPropertyTypesProps {
  propertyTypes: { name: string; isFiltered: boolean }[];
}
const CardPropertyTypes = ({ propertyTypes }: CardPropertyTypesProps) => {
  const { t } = useTranslation('search');
  const highlighted = propertyTypes?.filter(type => type.isFiltered);
  const rest = propertyTypes?.filter(type => !type.isFiltered);
  const more = highlighted.length + rest.length - 3;

  return (
    <Container>
      {highlighted
        ?.slice(0, 3)
        .map((type: any) => (
          <span className="property-type highlighted">{type.name}</span>
        ))}

      {3 - highlighted.length > 0 &&
        rest
          ?.slice(0, 3 - highlighted?.length)
          .map((type: any) => (
            <span className="property-type">{type.name}</span>
          ))}

      {more > 0 && <span>{`+${more} ${t('more')}`}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 4px 0;
  color: #1a2028;
  font-size: 12px;
  font-family: materialRegular;
  overflow-x: auto;

  .property-type {
    padding: 0 4px;

    &.highlighted {
      color: rgb(255, 94, 0);
    }
    &:first-child {
      padding-inline-start: 0;
    }

    &:not(:last-child) {
      border-inline-end: 1px solid #d3dbe6;
    }
  }

  span {
    padding-inline-start: 4px;
  }
`;

export default CardPropertyTypes;
